<div class="tvd-wrapper flex flex-col flex-grow gap-6 justify-between min-h-fit ml-[80px] px-8 py-6 bg-light-blue">

    <div class="tvd-header flex w-full flex-col h-fit sm:gap-2 lg:flex-row lg:justify-between">
        <div class="tvd-header-left flex flex-col gap-2 w-2/3">
            <tvd-overall
                id="tvd-overall"
                [value]=tvdOverallData
                >
            </tvd-overall>

            <div class="tvd-display-rounding-container">
                <toggle-switch label="Display in Rounded Numbers" [isCheckedByDefault]="displayInRoundedNumber" (toggleChange)="toggleRounding()"/>
            </div>

        </div>
        <div class="tvd-header-right flex gap-x-4 gap-y-4 h-fit items-center flex-wrap sm:justify-start lg:justify-end">
            <button class="adjust-cost-assumptions-button neptune-button-white" *ngIf="isCostAssumptionsVisible" (click)="openSideDrawer()">
                <span id="adjustcostassumptions">{{costCurrencyCode | currencySymbol}} Adjust Cost Assumptions</span>
            </button>

            <!-- If in presentation selection mode hide all buttons except Cost Assumptions -->
            <ng-container *ngIf="!makingSelectionsState">
                <button *ngIf="tvdProgramScope==availablePrograms.ALL" (click)="addCustomTile();" class="add-custom-tile-button neptune-button-white">
                    <img src="assets/shared-icons/neptune-icon-blue-plus-sign.svg" />
                    <span>Add Custom Tile</span>
                </button>
                <ng-container *ngIf="customTilesDict?.size != 0">
                    <button class="clear-custom-tile-button neptune-button-white" (click)="clearCustomTiles()">
                        <span>Clear Custom Tiles</span>
                    </button>
                </ng-container>

                <button *ngIf="tvdProgramScope==availablePrograms.ALL" (click)="toggleMakingSelectionsState()" class="add-to-presentation-button neptune-button-white">
                    <img src="assets/shared-icons/neptune-icon-blue-plus-sign.svg" />
                    <span class="text-base" *ngIf="!isMetricSelected">Add To Presentation</span>
                    <span class="text-base" *ngIf="isMetricSelected">Edit Selected Metrics</span>
                </button>

                <div class="enterprise-terms-button-container flex items-stretch">
                    <button
                        type="button"
                        class="enterprise-terms-button flex-1 basis-0 whitespace-nowrap rounded-r-none transition-colors outline-none focus-visible:ring focus-visible:ring-purple-400"
                        [ngClass]="showInEnterpriseTerms ? 'neptune-button-blue' : 'neptune-button-white hover:bg-slate-100'"
                        (click)="!showInEnterpriseTerms && toggleShowEnterpriseTerms()"
                    >
                        Enterprise Terms
                    </button>

                    <button
                        type="button"
                        class="division-terms-button flex-1 basis-0 whitespace-nowrap rounded-l-none transition-colors outline-none focus-visible:ring focus-visible:ring-purple-400"
                        [ngClass]="!showInEnterpriseTerms ? 'neptune-button-blue' : 'neptune-button-white hover:bg-slate-100'"
                        (click)="showInEnterpriseTerms && toggleShowEnterpriseTerms()"
                    >
                        Division Terms
                    </button>

                    <div class="information-tooltip flex justify-center items-center ml-2">
                        <information-tooltip [toolTipType]="infoTooltipType.EnterpriseTerms"/>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="tvd-body flex flex-col bg-white gap-6">
        <!-- Program switcher tabs -->
        <div class="program-switch-container flex grow w-full justify-between items-center">
            <div *ngFor="let program of availableProgramTabs"
                class="flex justify-center text-sm w-1/3 px-4 py-3 hover-pointer items-center border-solid border-white"
                [ngClass]="tvdProgramScope==program? 'border-b-blue text-neptune-default': 'text-neptune-neutral'"
                (click)="changeScope(program)"
            > {{program}}
            </div>
        </div>

        <div class="tvd-metrics-container flex flex-col grow">
            <div class="tvd-value-pillars flex bg-neptune-gradient mx-6 items-stretch" [ngClass]="expandedValuePillarId || makingSelectionsState ? 'rounded-t-[36px]' : 'rounded-[36px]'">
                <div class="flex grow h-full" [ngClass]="expandedValuePillarId || makingSelectionsState ? 'px-6 pt-6' : 'p-6'">
                    <div *ngFor="let item of valuePillars; trackBy: trackByValuePillar" class="value-pillar w-1/3" [id]="item">
                        <tvd-value-pillar-summary
                            [valuePillar]=item
                            [selectedProgram] = tvdProgramScope
                            [noMetricsForValuePillar]="!hasMetricsForPillar(item)"
                            [isExpanded]="expandedValuePillarId === item"
                            (toggleRequested)="onValuePillarToggle(item)"
                            (createCustomTileRequested)="addCustomTile()"
                            [makingSelectionsState]="makingSelectionsState"
                            />
                    </div>
                </div>
            </div>

            <div class="eroi-tiles-container flex flex-col gap-6 p-6">
                <div
                    id="business-outcomes-tiles"
                    class="gap-6 px-6 justify-center"
                    [ngClass]="{
                        'flex flex-col': expandedValuePillarId === TvdValuePillar.BusinessOutcomes || makingSelectionsState,
                        'hidden': !(expandedValuePillarId === TvdValuePillar.BusinessOutcomes || makingSelectionsState),
                        'py-6 rounded-md bg-neptune-special': makingSelectionsState,
                        'border-2 border-solid border-blue': businessOutcomesSelected && makingSelectionsState
                    }"
                >
                    <ng-container *ngIf="makingSelectionsState">
                        <ng-container
                            *ngTemplateOutlet="selectionState;
                                context: {
                                    label: 'Business Outcomes',
                                    class: 'business-outcomes-selection-state',
                                    selected: businessOutcomesSelected,
                                    toggleFunction: toggleBusinessOutcomesBox.bind(this),
                                    countFunction: countAvailableBusinessOutcomes.bind(this)
                                }">
                        </ng-container>
                    </ng-container>

                    <div class="tiles flex gap-6">
                        <div class="eroi-tiles flex flex-wrap w-full items-stretch content-start gap-6">
                            <!--Config-driven tile rendering — BusinessOutcomesTilesConfig -->
                            <eroi-metric *ngFor="let tile of visibleBusinessOutcomesTiles()"
                                [id]="tile.id"
                                [metricId]="tile.metricId"
                                [groupId]="getCurrentGroupId()"
                                (unselected)="checkTotalTilesSelected(tile.metricId, tile.valuePillar); automaticBucketToggleOff(tile.valuePillar);"
                                (selected)="checkTotalTilesSelected(tile.metricId, tile.valuePillar); automaticBucketToggle(tile.valuePillar);"
                                [makingSelectionsState]="makingSelectionsState"
                                [selectionMapping]="selectedItemsDict"
                                [data]="getDataByMetricId(tile.metricId)"
                                [measurementSystem]="measurementSystem">
                            </eroi-metric>
                            <custom-tile-item
                            *ngFor="let item of GetCustomTilesGivenValuePillar(TvdValuePillar.BusinessOutcomes)"
                            [id] = "item.title"
                            [makingSelectionsState]="makingSelectionsState"
                            [selectionMapping]="selectedItemsDict"
                            [customTilesDict]="customTilesDict"
                            [selectedItem]="selectedItemsDict.get(item.title)?.[1]"
                            [addedToPres]="selectedItemsDict.get(item.title)?.[2]"
                            (unselected)="checkTotalTilesSelected(item.title, TvdValuePillar.BusinessOutcomes); automaticBucketToggleOff(TvdValuePillar.BusinessOutcomes);"
                            (selected)="checkTotalTilesSelected(item.title, TvdValuePillar.BusinessOutcomes); automaticBucketToggle(TvdValuePillar.BusinessOutcomes);"
                            >
                            </custom-tile-item>
                        </div>
                    </div>
                </div>

                <!-- Operational Performance tiles -->
                <div
                    id="operational-performance-tiles"
                    class="gap-6 px-6 justify-center"
                    [ngClass]="{
                        'flex flex-col': expandedValuePillarId === TvdValuePillar.OperationalPerformance || makingSelectionsState,
                        'hidden': !(expandedValuePillarId === TvdValuePillar.OperationalPerformance || makingSelectionsState),
                        'py-6 rounded-md bg-neptune-special': makingSelectionsState,
                        'border-2 border-solid border-blue': operationalPerformanceSelected && makingSelectionsState
                    }"
                >
                    <ng-container *ngIf="makingSelectionsState">
                        <ng-container
                            *ngTemplateOutlet="selectionState;
                                context: {
                                    label: 'Operational Performance',
                                    class: 'operational-performance-selection-state',
                                    selected: operationalPerformanceSelected,
                                    toggleFunction: toggleOperationalPerformanceBox.bind(this),
                                    countFunction: countAvailableOperationalPerformance.bind(this)
                                }">
                        </ng-container>
                    </ng-container>

                    <div class="tiles flex gap-6">
                        <div class="eroi-tiles flex flex-wrap w-full items-start content-start gap-6">
                            <!--Composite tiles (config-driven) — OperationalPerformanceCompositeTilesConfig -->
                            <ng-container *ngFor="let composite of visibleOperationalPerformanceCompositeTiles()">
                                <composite-eroi-metric
                                    [id]="composite.id"
                                    [groupId]="getCurrentGroupId()"
                                    [data]="getSubComponentsData(composite.id)"
                                    [makingSelectionsState]="makingSelectionsState"
                                    [showInfoTooltip]="composite.showInfoTooltip"
                                    [measurementSystem]="measurementSystem">
                                    <ng-container *ngFor="let child of visibleCompositeChildren(composite)">
                                        <eroi-metric
                                            [id]="child.id"
                                            [metricId]="child.metricId"
                                            [groupId]="getCurrentGroupId()"
                                            (unselected)="checkTotalTilesSelected(child.metricId, composite.valuePillar); automaticBucketToggleOff(composite.valuePillar);"
                                            (selected)="checkTotalTilesSelected(child.metricId, composite.valuePillar); automaticBucketToggle(composite.valuePillar);"
                                            [makingSelectionsState]="makingSelectionsState"
                                            [selectionMapping]="selectedItemsDict"
                                            [data]="getDataByMetricId(child.metricId)"
                                            [isSubComponent]="child.isSubComponent || false"
                                            [measurementSystem]="measurementSystem">
                                        </eroi-metric>
                                    </ng-container>
                                </composite-eroi-metric>
                            </ng-container>
                            <!--Individual tiles (config-driven) — OperationalPerformanceTilesConfig -->
                            <eroi-metric *ngFor="let tile of visibleOperationalPerformanceTiles()"
                                [id]="tile.id"
                                [metricId]="tile.metricId"
                                [groupId]="getCurrentGroupId()"
                                (unselected)="checkTotalTilesSelected(tile.metricId, tile.valuePillar); automaticBucketToggleOff(tile.valuePillar);"
                                (selected)="checkTotalTilesSelected(tile.metricId, tile.valuePillar); automaticBucketToggle(tile.valuePillar);"
                                [makingSelectionsState]="makingSelectionsState"
                                [selectionMapping]="selectedItemsDict"
                                [data]="getDataByMetricId(tile.metricId)"
                                [measurementSystem]="measurementSystem">
                            </eroi-metric>
                            <custom-tile-item
                                *ngFor="let item of GetCustomTilesGivenValuePillar(TvdValuePillar.OperationalPerformance)"
                                [id] = "item.title"
                                [makingSelectionsState]="makingSelectionsState"
                                [selectionMapping]="selectedItemsDict"
                                [customTilesDict]="customTilesDict"
                                [selectedItem]="selectedItemsDict.get(item.title)?.[1]"
                                [addedToPres]="selectedItemsDict.get(item.title)?.[2]"
                                (unselected)="checkTotalTilesSelected(item.title, TvdValuePillar.OperationalPerformance); automaticBucketToggleOff(TvdValuePillar.OperationalPerformance)"
                                (selected)="checkTotalTilesSelected(item.title, TvdValuePillar.OperationalPerformance); automaticBucketToggle(TvdValuePillar.OperationalPerformance)"
                            >
                            </custom-tile-item>
                        </div>
                    </div>
                </div>

                <div
                    id="environmental-impact-tiles"
                    class="gap-6 px-6 justify-center"
                    [ngClass]="{
                        'flex flex-col': expandedValuePillarId === TvdValuePillar.EnvironmentalImpact || makingSelectionsState,
                        'hidden': !(expandedValuePillarId === TvdValuePillar.EnvironmentalImpact || makingSelectionsState),
                        'py-6 rounded-md bg-neptune-special': makingSelectionsState,
                        'border-2 border-solid border-blue': environmentalImpactSelected && makingSelectionsState
                    }"
                >
                    <ng-container *ngIf="makingSelectionsState">
                        <ng-container
                            *ngTemplateOutlet="selectionState;
                                context: {
                                    label: 'Environmental Impact',
                                    class: 'environmental-impact-selection-state',
                                    selected: environmentalImpactSelected,
                                    toggleFunction: toggleEnvironmentalImpactBox.bind(this),
                                    countFunction: countAvailableEnvironmentalImpact.bind(this)
                                }">
                        </ng-container>
                    </ng-container>

                    <div class="tiles flex gap-6">
                        <!--1: Composite tiles (config-driven) — EnvironmentalImpactCompositeTilesConfig -->
                        <div class="composite-eroi-tiles flex gap-6">
                            <ng-container *ngFor="let composite of visibleEnvironmentalImpactCompositeTiles()">
                                <composite-eroi-metric
                                    [id]="composite.id"
                                    [groupId]="getCurrentGroupId()"
                                    [data]="getSubComponentsData(composite.id)"
                                    [makingSelectionsState]="makingSelectionsState"
                                    [showInfoTooltip]="composite.showInfoTooltip"
                                    [measurementSystem]="measurementSystem">
                                    <ng-container *ngFor="let child of visibleCompositeChildren(composite)">
                                        <eroi-metric
                                            [id]="child.id"
                                            [metricId]="child.metricId"
                                            [groupId]="getCurrentGroupId()"
                                            (unselected)="checkTotalTilesSelected(child.metricId, composite.valuePillar); automaticBucketToggleOff(composite.valuePillar);"
                                            (selected)="checkTotalTilesSelected(child.metricId, composite.valuePillar); automaticBucketToggle(composite.valuePillar);"
                                            [makingSelectionsState]="makingSelectionsState"
                                            [selectionMapping]="selectedItemsDict"
                                            [data]="getDataByMetricId(child.metricId)"
                                            [isSubComponent]="child.isSubComponent || false"
                                            [measurementSystem]="measurementSystem">
                                        </eroi-metric>
                                    </ng-container>
                                </composite-eroi-metric>
                            </ng-container>
                        </div>

                        <!--Individual and Custom tiles (config-driven) — EnvironmentalImpactTilesConfig -->
                        <div class="eroi-tiles flex flex-wrap w-full items-stretch content-start gap-6">
                            <eroi-metric *ngFor="let tile of visibleEnvironmentalImpactTiles()"
                                [id]="tile.id"
                                [metricId]="tile.metricId"
                                [groupId]="getCurrentGroupId()"
                                (unselected)="checkTotalTilesSelected(tile.metricId, tile.valuePillar); automaticBucketToggleOff(tile.valuePillar);"
                                (selected)="checkTotalTilesSelected(tile.metricId, tile.valuePillar); automaticBucketToggle(tile.valuePillar);"
                                [makingSelectionsState]="makingSelectionsState"
                                [selectionMapping]="selectedItemsDict"
                                [data]="getDataByMetricId(tile.metricId)"
                                [measurementSystem]="measurementSystem">
                            </eroi-metric>

                            <custom-tile-item
                                *ngFor="let item of GetCustomTilesGivenValuePillar(TvdValuePillar.EnvironmentalImpact)"
                                [id] = "item.title"
                                [makingSelectionsState]="makingSelectionsState"
                                [selectionMapping]="selectedItemsDict"
                                [customTilesDict]="customTilesDict"
                                [selectedItem]="selectedItemsDict.get(item.title)?.[1]"
                                [addedToPres]="selectedItemsDict.get(item.title)?.[2]"
                                (unselected)="checkTotalTilesSelected(item.title, TvdValuePillar.EnvironmentalImpact); automaticBucketToggleOff(TvdValuePillar.EnvironmentalImpact);"
                                (selected)="checkTotalTilesSelected(item.title, TvdValuePillar.EnvironmentalImpact); automaticBucketToggle(TvdValuePillar.EnvironmentalImpact); "
                            >
                            </custom-tile-item>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Show Water, Energy and Waste (Plastic + Cardboard) quantity totals at a quick glance-->
        <div class="tvd-metric-summary-container relative flex flex-col gap-4 mx-6 mb-12 justify-around lg:flex-row">
            <div *ngFor="let metric of summaryPillMetrics" class="w-1/3 rounded-[28px] bg-neptune-gradient lg:min-w-[280px] md:min-w-[150px]">
                <tvd-metric-summary [metricId]="metric" [data]="getSummaryPillData(metric)" [selectedProgram]="tvdProgramScope" [measurementSystem]="measurementSystem" />
            </div>
        </div>
    </div>

    <ng-container *ngIf="hasTvdByPrograms">
        <tvd-program-table />
    </ng-container>



    <!-- Modal Wrappers and additional components-->
    <ng-container *ngIf="selectionsPreviewState || custTileEntryVisible || custTileEditVisible">
        <div class="neptune-modal-cover">
            <custom-tile-entry-panel
                (hideCustEntryTilePanel)="hideCustEntryTilePanel(); hideCover();"
                (newCustomTileAdded)="checkValuePillarTileCountAfterCustomTile($event)"
                *ngIf="custTileEntryVisible"
                [customTilesDict]="customTilesDict"
                [filtersSelected]="filters">
            </custom-tile-entry-panel>

            <app-custom-tile-edit-panel
                (hideCustEditTilePanel)="hideCustEditTilePanel(); showCover();"
                (customTileEdited)="checkValuePillarTileCountAfterCustomTile($event)"
                [customTilesDict]="customTilesDict"
                [selectedItemsDict]="selectedItemsDict"
                *ngIf="custTileEditVisible">
            </app-custom-tile-edit-panel>

            <tvd-presentation-preview
                *ngIf="selectionsPreviewState"
                [selectedItemsDict]="selectedItemsDict"
                [customTilesDict]="customTilesDict"
                (saveSelection)="addToPresentation()"
                (exitPreview)="toggleSelectionsPreviewState()"
                (clearSelection)="clearSelectedTilesForPresentation()"
            >
            </tvd-presentation-preview>
        </div>
    </ng-container>

    <ng-container *ngIf="isDrawerOpen">
        <app-tvd-sidenavbar
            [isOpen]="isDrawerOpen"
            (closeSideDrawer)="closeSideDrawer()">
        </app-tvd-sidenavbar>
    </ng-container>
</div>

<!-- Making selections state bottom bar, outside of main container to make it appear as a footer -->
<div class="select-feature fixed bottom-0 neptune-page-bottom-container w-full gap-6 bg-white box-border px-8 py-4" *ngIf="makingSelectionsState" [hidden]="tvdProgramScope!=availablePrograms.ALL">
    <div class="flex justify-between items-center w-full">
        <div class="selection-count flex justify-start items-center text-xl ml-20">
            <span class="text-bold">{{countSelectedItems()}}</span>&nbsp;item(s) selected
        </div>
        <div class="selection-actions flex gap-6 justify-end items-center">
            <button class="neptune-button-white" (click)="cancelMakingSelectionsState()">Cancel</button>
            <button [ngClass] = "countSelectedItems() != 0 ? 'neptune-button-white' : 'neptune-button-disabled'" [disabled]="countSelectedItems() === 0" (click)="toggleSelectionsPreviewState()">Preview</button>
            <button class="neptune-button-blue" (click)="addToPresentation()">Done</button>
        </div>
    </div>
</div>

<!-- Selection state template -->
 <ng-template
    #selectionState
    let-label="label"
    let-class="class"
    let-selected="selected"
    let-toggleFunction="toggleFunction"
    let-countFunction="countFunction"
>
    <div class="{{class}} flex justify-between items-center pb-4" [ngClass]="countFunction() > 0 ? 'neptune-border-b-1 border-sky-blue' : ''">
        <span class="text-2xl">{{ label }}</span>
        <ng-container *ngIf="countFunction() > 0">
            <button class="add-entire-value-pillar-button" (click)="toggleFunction()" [ngClass]="!selected ? 'neptune-button-white' : 'neptune-button-blue'">
                <ng-container *ngIf="!selected; else addedButton">
                    <img src="assets/shared-icons/neptune-icon-blue-plus-sign.svg" />
                    Add Entire Value Pillar
                </ng-container>
                <ng-template #addedButton>
                    Entire Value Pillar Added
                    <img src="assets/shared-icons/neptune-icon-white-tick.svg" />
                </ng-template>
            </button>
        </ng-container>
        <ng-container *ngIf="countFunction()==0">
            <span class="text-base italic">{{isPestDivision && label == 'Business Outcomes' ? 'No applicable TVD metrics' : 'No Data Available'}}</span>
        </ng-container>
    </div>
 </ng-template>

<ng-container *ngIf="showLoadingOverlay" [ngTemplateOutlet]="loadingTemplate"></ng-container>

<!-- Loading template to overlay the entire page -->
 <ng-template #loadingTemplate>
  <div class="neptune-modal-cover">
        <loader [size]="'medium'"></loader>
  </div>
</ng-template>
